import { ReactNode } from 'react';
import { Stack, Typography } from '@mui/material';
import { IProductDto } from 'api/products/dto';
import CollapsibleSection from 'components/v2/accordion/CollapsibleSection';
import OrderItem from 'components/v2/text/OrderItem';
import { CurrencyCode } from 'constants/enums/general';
import { useLocalization } from 'localization';
import { userStore } from 'stores/userStore';

type OrderSection = {
  packages: IProductDto[];
  title: string | ReactNode;
  subTitle?: string | ReactNode;
  packageCurrency?: string;
};

const NewPackageSection = (props: OrderSection) => {
  const { packages, title, packageCurrency = CurrencyCode.DKK, subTitle } = props;
  const { f } = useLocalization();
  const { user } = userStore();
  const showPrice = user?.visiblePrices;

  return (
    <CollapsibleSection title={title} subTitle={subTitle}>
      <Stack gap={1.25}>
        {packages.map((p: IProductDto, i) => {
          return (
            <Stack key={i}>
              <Typography variant="h6">{p.name}</Typography>
              {p?.children?.map((item, index) => (
                <OrderItem
                  visiblePrice={showPrice}
                  key={index}
                  name={item?.name ?? ''}
                  quantity={item.quantity ?? 1}
                  price={
                    showPrice ? `(${f(item?.discountedPrice ?? 0, { currency: packageCurrency, decimals: 2 })})` : ''
                  }
                />
              ))}
            </Stack>
          );
        })}
      </Stack>
    </CollapsibleSection>
  );
};

export default NewPackageSection;
